<template>
	<div class="hello">
		<RobotSocket ref="robotSocket" :nowTime='nowTime' @backSockertData='doSocker($event)' />
		<Head type='admin' @tapStatus="changeTap($event)" @out='headOut($event)'></Head>
		<audio :src="phoneMp3" loop ref="pnhoneAudio"></audio>

		<el-dialog :visible.sync="flvOpen" width="100%" center>
			<div style="position: fixed;width: 100%;height: 100%;left: 0%;top: 0%;background-color: black;">
				<i class="el-icon-close"
					style="position: absolute;right: 10px;top: 10px;cursor: pointer;font-size: 2vw;z-index: 99;color: white;"
					@click="flvOpen = false"></i>
				<RobotFlv :playStatus='true' :ststus='checkFlv.ststus'
					:rid='checkFlv.robotId' :rtmpSrc="(checkFlv.robotType == '01' || checkFlv.robotType == '06') ? checkFlv.rFront : checkFlv.flvPtz" />
			</div>
		</el-dialog>

		<el-dialog :visible.sync="ifVoice" width="30%" center>
			<div style="width: 100%;height: 100%;position: relative;">
				<img style="width: 100%;height: 100%;" src="../../../static/imgV2/newDialog-7.png" alt="">
				<div class="gifDom">
					<img src="../../../static/imgV2/breathe.gif" alt="">
					<div class="title-top-text">{{ languageJson.OperationTips }}</div>
				</div>
				<div
					style="position: absolute;width: 100%;top: 35%;font-size: 1vw;color: white;font-weight: 600;text-align: center;">
					【{{ ifVoiceObj.robotName }}】{{ languageJson.Emergency }}</div>
				<div
					style="position: absolute;left:10%;width: 80%;bottom: 10%;display: flex;justify-content: space-between;">
					<div class="newBtn1" style="width: 40%;" @click='closeVoice()'>{{ languageJson.hangup }}</div>
					<div class="newBtn1 newBtn1do" style="width: 40%;" @click='openVoice()'>{{ languageJson.answer }}</div>
				</div>
			</div>
		</el-dialog>

		<el-dialog :visible.sync="dialogVisible" width="30%" center>
			<div style="width: 100%;height: 100%;position: relative;">
				<img style="width: 100%;" src="../../../static/imgV2/newDialog-7.png" alt="">
				<div class="gifDom">
					<img src="../../../static/imgV2/breathe.gif" alt="">
					<div class="title-top-text">{{ languageJson.OperationTips }}</div>
				</div>
				<div
					style="position: absolute;width: 100%;top: 35%;font-size: 1.2vw;color: white;font-weight: 600;text-align: center;">
					{{ languageJson.ExitText }}</div>
				<div
					style="position: absolute;left:10%;width: 80%;bottom: 10%;display: flex;justify-content: space-between;">
					<div class="newBtn1" style="width: 40%;" @click="dialogVisible = false">{{ languageJson.Cancel }}</div>
					<div class="newBtn1 newBtn1do" style="width: 40%;" @click="getOut()">{{ languageJson.Exit }}</div>
				</div>
			</div>
		</el-dialog>

		<div class="groupDom">
			<img class="groupDom-left" v-if="groupList.length > 5" src="../../../static/imgV2/leftCheck.png"
				@click="mapScroll('left')" alt="">
			<img class="groupDom-right" v-if="groupList.length > 5" src="../../../static/imgV2/rightCheck.png"
				@click="mapScroll('right')" alt="">
			<div class="tapGroup">
				<div class="groupLi" v-for="(obj, $index) in groupList" :key="$index" @click="changeGroup($index)">
					<img :src="obj.check ? check0 : check1" alt="">
					<div class="groupLi-title">{{ obj.name }}</div>
				</div>
			</div>
		</div>

		<div class="divCenter">
			<div class="box">
				<div v-for="(item, index) in centerDIV" :class="changeRobotX2(item.number) ? 'box-item box-item-x2' :'box-item'"
					:key="index" @click="toDetail(item, false)">
					<div class="title">
						<div :class="changeRobotX2(item.number) ? 'name nameX2 min-box' : 'name min-box'">{{item.rName}}&nbsp; <span v-if="item.onlineStatus == '1'">{{item.ststusName}}</span> </div>
						<div class="power" v-if="item.onlineStatus == '1'" :style="{'marginRight': item.power =='100' ? '1.8vw': '1.5vw'}">
							<div class="power-text">&nbsp;{{item.power}}%</div>
							<RobotPower class="power-icon" :number='item.power' :type='item.ststus'
								:state='item.robotType' />
						</div>
					</div>

					<div class="offline" v-if="item.onlineStatus == '2'">
						<div :class="changeRobotX2(item.number) ? 'label labelx2' : 'label'">{{ languageJson.Robotoffline }}</div>
					</div>

					<img v-if="item.number == ifVoiceObj.robotNumber" class="itemBackImg" :src="changeRobotX2(item.number) ? backImageRed2 : backImageRed1" alt="">
					<img v-else class="itemBackImg" :src="changeRobotX2(item.number) ? backImage2 : backImage1" alt="">

					<div class="video" v-if="item.onlineStatus == '1'">
						<RobotFlv playAudo='stop' @loading="loading($event, index)" :playStatus='item.playStatus' @playStop='playStop($event, index)'
							:vSocketData='vSocketData' :ststus='item.ststus' :rid='item.robotId'
							:rtmpSrc="(item.robotType == '01' || item.robotType == '06') ? item.rFront : item.flvPtz" />
					</div>
					<div class="footer" v-if="item.onlineStatus == '1'">
						<div class="l">
							<img :src="item.playStatus ? play0 : play1" @click.stop="flvPlay(item.playStatus, index)" />
							<img src="../../../static/imgV2/Refresh.png" @click.stop="flvPlay(false,index)" />
						</div>
						<div class="r">
							<img src="../../../static/imgV2/fullScreen-0.png" @click.stop="videoFull(item)">
							<div :class="changeRobotX2(item.number) ? 'btns btnsx2': 'btns'" @click.stop="videoX2(item)"></div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import {
		getItem,
		setToken,
		setItem,
		removeItem,
		removeToken
	} from '@/utils/auth'
	import {
		getGroup,
		saveRobotHistory,
		getVideoList
	} from '@/api/admin'
	import Head from '@/components/Head.vue'
	import RobotSocket from '@/components/RobotSocket.vue'
	import RobotFlv from '@/components/flv264V3.vue'
	import RobotPower from '@/components/RobotPower.vue'

	export default {
		name: 'login',
		components: {
			Head,
			RobotSocket,
			RobotFlv,
			RobotPower
		},
		data() {
			return {
				languageJson: languageJson,
				languageCheck: localStorage.getItem('language'),
				check0: require('../../../static/imgV2/checkSelect-0.png'),
				check1: require('../../../static/imgV2/checkSelect-1.png'),
				play0: require('../../../static/imgV2/flvstop.png'),
				play1: require('../../../static/imgV2/flvplay.png'),
				phoneMp3: require('../../../static/audio/phone.mp3'),
				backImage1: require('../../../static/imgV2/robot-x1.png'),
				backImage2: require('../../../static/imgV2/robot-x2.png'),
				backImageRed1: require('../../../static/imgV2/robot-red-x1.png'),
				backImageRed2: require('../../../static/imgV2/robot-red-x2.png'),
				nowTime: new Date().getTime(),
				tapType: false,
				dialogVisible: false,
				groupList: [],
				centerDIV: [],
				vSocketData: {},
				ifVoice: false,
				ifVoiceObj: {
					useVoice: "",
					robotNumber: "",
					robotName: ""
				},
				flvOpen: false,
				checkFlv: {
					playStatus: true,
					ststus: "",
					robotId: "",
					robotType: "",
					rFront: "",
					flvPtz: ""
				}
			}
		},
		mounted() {
			let that = this
			that.getGroup()
		},
		methods: {
			changeRobotX2(number) {
				if (getItem("robotx2")) {
					let getRobot = getItem("robotx2").split(',');
					return getRobot.includes(number);
				} else {
					return false
				}
			},
			loading(item, index) {
			},
			playStop(type, index) {
				this.centerDIV[index].playStatus = (type == 'play') ? true : false
			},
			toDetail(data, playStatus) {
				if (data.onlineStatus == '1') {
					this.$router.push({
						// path: '/detail',
						name: 'detail',
						query: {
							robotId: data.robotId,
							type: 'admin'
						},
						params: {
							ifPlay: playStatus
						}
					})
				} else {
					this.$notify.error({
						title: languageJson.RobotNotOnline
					})
				}
			},
			robotX2(data) {
				this.checkFlv = data
				this.flvOpen = true
			},
			videoFull(data) {
				this.checkFlv = data
				this.flvOpen = true
			},
			videoX2(item) {
				if (getItem("robotx2")) {
					let getRobot = getItem("robotx2").split(',');
					if ( getRobot.includes(item.number) ) {
						getRobot.splice(getRobot.indexOf(item.number), 1)
						setItem("robotx2", getRobot.toString())
					} else {
						setItem("robotx2", (getItem("robotx2") + ',' + item.number))
					}
				} else {
					setItem("robotx2", item.number)
				}
				item.x2 = !item.x2;
				this.centerDIV = this.centerDIV.sort(this.order);
			},
			order(a, b) {
				if (a.x2 > b.x2) {
					return -1;
				} else if (a.x2 < b.x2) {
					return 1;
				} else {
					return 0;
				}
			},
			closeVoice() {
				let that = this
				that.$confirm(that.languageJson.ConfirmHangUp, that.languageJson.prompt, {
					confirmButtonText: that.languageJson.end,
					cancelButtonText: that.languageJson.Cancel,
					type: "warning",
				}).then(() => {
					that.ifVoice = false
					that.ifVoiceObj.useVoice = ""
					that.ifVoiceObj.robotNumber = ""
					that.ifVoiceObj.robotName = ""
				}).catch(() => {})
			},
			openVoice() {
				let that = this
				let findPlay = that.centerDIV.find(res => res.number == that.ifVoiceObj.robotNumber )
				that.toDetail(findPlay, true)
			},
			flvPlay(type, index) {
				this.centerDIV[index].playStatus = !type
				this.centerDIV = JSON.parse(JSON.stringify(this.centerDIV))
			},
			getVideoList(groups) {
				let that = this
				let checkGroupList = []
				groups.forEach(res => {
					if (res.check) checkGroupList.push(res.groupingId)
				})
				if (checkGroupList.length == 0) {
					that.centerDIV = []
				} else {
					getVideoList({
						groupingIds: checkGroupList.toString()
					}).then(res => {
						if (res && res.data) {
							that.centerDIV = res.data.map(item => {
								return {
									...item,
									x2: that.changeRobotX2(item.number)
								}
							})
							that.centerDIV.forEach(res => {
								res.playStatus = false
							})
							that.centerDIV = JSON.parse(JSON.stringify(that.centerDIV))
							that.centerDIV = that.centerDIV.sort(that.order);
						} else {
							that.centerDIV = []
						}
					})
				}
			},
			changeGroup(index) {
				let that = this
				that.groupList[index].check = that.groupList[index].check ? false : true
				that.getVideoList(that.groupList)
			},
			mapScroll(type) {
				let leftData = document.getElementsByClassName('tapGroup')[0].scrollLeft
				if (type === 'left') {
					document.getElementsByClassName('tapGroup')[0].scrollLeft = leftData - 200
				} else {
					document.getElementsByClassName('tapGroup')[0].scrollLeft = leftData + 200
				}
			},
			getGroup() {
				let that = this
				getGroup(getItem('tenantInfoId')).then(res => {
					if (res.data && res.data.length > 0) {
						res.data.forEach((res, index) => {
							that.groupList.push({
								...res,
								check: true
							})
						})
						that.getVideoList(that.groupList)
					} else {
						that.groupList = []
					}
				})
			},
			changeTap(data) {
				this.tapType = data
			},
			doSocker(socketData) {
				let that = this
				that.vSocketData = socketData
				if (socketData.socketType == '1') {
					for (let i = 0; i < that.centerDIV.length; i++) {
						if (that.centerDIV[i].robotId === socketData.robotId) {
							that.centerDIV[i].ststusName = that.languageCheck == 'English' ? socketData.enStstusName : socketData.ststusName
							that.centerDIV[i].power = socketData.power
							that.centerDIV[i].ststus = socketData.ststus
						}
					}
					that.centerDIV = JSON.parse(JSON.stringify(that.centerDIV))
				} else if (socketData.socketType == '7') {
					for (let i = 0; i < that.centerDIV.length; i++) {
						if (that.centerDIV[i].robotId === socketData.robotId) {
							that.centerDIV[i].onlineStatus = socketData.onlineStatus
						}
					}
				} else if (socketData.socketType == '17') {
					if (socketData.status == '0') {
						that.ifVoice = true
						that.ifVoiceObj.useVoice = socketData.useVoice
						that.ifVoiceObj.robotNumber = socketData.robotNumber
						that.ifVoiceObj.robotName = socketData.robotName
					}
				}
			},
			headOut(data) {
				this.dialogVisible = true
			},
			getOut() {
				removeToken()
				removeItem('differtime')
				removeItem('loginSuccess')
				this.dialogVisible = false
				this.$router.push({
					name: 'login'
				})
			}
		},
		watch: {
			ifVoice: {
				immediate: true,
				handler(newValue, oldValue) {
					let that = this
					if (newValue) {
						that.$nextTick(() => {
							if (that.$refs.pnhoneAudio) that.$refs.pnhoneAudio.play()
						})
						setTimeout(() => {
							that.ifVoice = false
						}, 60000)
					} else {
						that.$nextTick(() => {
							if (that.$refs.pnhoneAudio) that.$refs.pnhoneAudio.pause()
						})
					}
				}
			}
		}
	}
</script>

<style scoped lang="less">
	@import "./admin.less";
</style>



// WEBPACK FOOTER //
// src/page/admin/index.vue